import { FC } from 'react';

import headerButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/header/header_button_click';
import { Link } from '@hh.ru/redux-spa-middleware';

import { useDashboardRoute } from 'hooks/useDashboardRoute';

import LogoIconSmall from 'components/Logo/clickme_logo_24.svg';
import LogoIconMedium from 'components/Logo/clickme_logo_40.svg';

import styles from 'components/Logo/Logo.module.less';

export const enum LogoSize {
    Medium = 'medium',
    Small = 'small',
}

const LOGOS = {
    [LogoSize.Medium]: LogoIconMedium,
    [LogoSize.Small]: LogoIconSmall,
};

export const Logo: FC<{ size?: LogoSize }> = ({ size = LogoSize.Medium }) => {
    const dashboardRoute = useDashboardRoute();

    return (
        <Link
            className={styles.wrapper}
            to={dashboardRoute}
            onClick={() => headerButtonClick({ buttonName: 'clickme_logo' })}
        >
            <img src={LOGOS[size]} className={styles[size]} />
        </Link>
    );
};
